import Layout from "components/layout/Layout";
const DataResidency = () => {
    return (
        <Layout
            headerStyle={1}
            footerStyle={1}
            breadcrumbTitle={ <> Data <span>Residency</span> </> } >
            <section className="job-details-area pb-150">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-10">
                            <div className="job-details-content">
                                <div className="job-qualifications">
                                    <p className="info-one">
                                        At BodyLytiX, we prioritize your data privacy and security. By utilizing Amazon Web Services (AWS) infrastructure, we ensure that your data is stored and processed in compliance with regional regulations, providing both reliability and transparency. Your data is always under your control, enabling informed decisions about its use.
                                    </p>
                                    <p className="info-one">
                                        Our data residency policy reflects our commitment to safeguarding your information while adhering to regional regulations. Data residency refers to the geographic location where your data is stored and processed. This is an important consideration, as different countries have specific regulations governing the handling and protection of personal information.
                                    </p>
                                </div>
                                <div className="job-details-list-wrap">
                                    <h2 className="title-two">How BodyLytiX Manages Data Residency</h2>
                                    <ol>
                                        <li>
                                            Regional AWS Data Centers
                                            <p className="text-gray-600">
                                                BodyLytiX uses AWS’s global network of data centers to store and process your data in the region closest to you. This minimizes latency, enhances performance, and ensures compliance with local data residency requirements.
                                            </p>
                                        </li>
                                        <li>
                                            Compliance with Regulations
                                            <p className="text-gray-600">
                                                We align our data residency practices with applicable regulations, such as GDPR in the European Union and CCPA in the United States. AWS’s adherence to global compliance standards helps us ensure that your data is handled lawfully and ethically.
                                            </p>
                                        </li>
                                        <li>
                                            Compliance with Regulations
                                            <p className="text-gray-600">
                                                We align our data residency practices with applicable regulations, such as GDPR in the European Union and CCPA in the United States. AWS’s adherence to global compliance standards helps us ensure that your data is handled lawfully and ethically.
                                            </p>
                                        </li>
                                        <li>
                                            Localized Data Processing
                                            <p className="text-gray-600">
                                                For regions with strict data sovereignty laws, BodyLytiX ensures that personal data remains within the required jurisdiction and is processed locally without unauthorized transfers.
                                            </p>
                                        </li>
                                    </ol>
                                </div>
                                <div className="job-details-list-wrap">
                                    <h2 className="title-two">
                                        Why AWS?
                                    </h2>
                                    <ul className="list-wrap">
                                        <li>
                                            <b>Security First:</b> AWS employs state-of-the-art security measures, including encryption, intrusion detection, and network firewalls, to protect your data at every stage.
                                        </li>
                                        <li>
                                            <b>Global Reach:</b> With data centers across multiple regions worldwide, AWS allows us to deliver a seamless experience while meeting regional compliance needs.
                                        </li>
                                        <li>
                                            <b>Scalability and Reliability:</b> AWS’s infrastructure supports the scalability needed to accommodate growing user demand, ensuring your data remains secure and accessible.
                                        </li>
                                    </ul>
                                </div>
                                <div className="job-details-list-wrap">
                                    <h2 className="title-two">User Control and Consent</h2>
                                    <p className="info-one">
                                        At BodyLytiX, we believe in empowering you to control your data. You can manage your data settings, access information about where your data is stored, and make informed decisions about data sharing. Transparency and user consent are integral to our data residency practices.
                                    </p>
                                </div>
                                <div className="job-details-list-wrap">
                                    <h2 className="title-two">Our Promise</h2>
                                    <p className="info-one">
                                        With AWS as our trusted partner, we are committed to providing a secure and compliant platform where you can focus on your fitness and wellness journey, knowing your data is in safe hands. If you have any questions or concerns about our data residency practices, feel free to contact us.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </Layout>
    );
};
export default DataResidency;